import React from 'react';
import { Input, Label } from '@americanexpress/dls-react';
import {
  validateInputs,
  validateField,
} from '../../validators/vendorIntakeFormValidator';
import * as LABELCONST from '../../constants/constFileLabelsVendor';

const AmexContactInfo = (props) => {
  const { setFormErrors, setFormData, formData, formErrors } = props;
  return (
    <div className="margin-responsive fade-in">
      <div>
        <h1 className="header-text">{LABELCONST.AMERICAN_EXPRESS_CONTACT_INFORMATION}</h1>
        <div className="new-line" />
        <span>
          Please include the contact information for your American Express
          contact.
        </span>
        <div className="new-line" />
      </div>
      <div className="width-75">
        <Label className="pad-responsive-t">
          {LABELCONST.AMEX_CONTACT_NAME} <span className="dls-red">*</span>
        </Label>
        <Input
          id="amexContactName"
          maxLength={120}
          value={formData.amexContactName}
          onChange={(event) => {
            setFormData({
              ...formData,
              amexContactName: event.target.value,
            });
            setFormErrors({
              ...formErrors,
              amexContactName: validateField(
                event.target.value,
                'required',
                'Amex Contact Name'
              ),
            });
          }}
          onBlur={() =>
            setFormErrors({
              ...formErrors,
              amexContactName: validateField(
                formData.amexContactName,
                'required',
                'Amex Contact Name'
              ),
            })
          }
        />
        <p className="dls-red">{formErrors.amexContactName}</p>

        <Label className="pad-responsive-t">
          {LABELCONST.AMEX_CONTACT_EMAIL} <span className="dls-red">*</span>
        </Label>
        <Input
          id="amexContactEmail"
          maxLength={100}
          value={formData.amexContactEmail}
          onChange={(event) => {
            setFormData({
              ...formData,
              amexContactEmail: event.target.value,
            });
            setFormErrors({
              ...formErrors,
              amexContactEmail: validateField(
                event.target.value,
                'required',
                'Amex Contact Email'
              ),
            });
          }}
          onBlur={() =>
            setFormErrors({
              ...formErrors,
              amexContactEmail: validateField(
                formData.amexContactEmail,
                'amexEmail',
                'Amex Contact'
              ),
            })
          }
        />
        <p className="dls-red">{formErrors.amexContactEmail}</p>

        <Label className="pad-responsive-t">
          {LABELCONST.AMEX_CONTACT_TELEPHONE_NUMBER}
          <span className="dls-red">*</span>
        </Label>
        <Input
          id="amexContactNumber"
          maxLength={50}
          value={formData.amexContactNumber}
          onChange={(event) => {
            setFormData({
              ...formData,
              amexContactNumber: event.target.value,
            });
            setFormErrors({
              ...formErrors,
              amexContactNumber: validateField(
                event.target.value,
                'phone',
                'Amex'
              ),
            });
          }}
          onBlur={() =>
            setFormErrors({
              ...formErrors,
              amexContactNumber: validateField(
                formData.amexContactNumber,
                'phone',
                'Amex'
              ),
            })
          }
        />
        <p className="dls-red">{formErrors.amexContactNumber}</p>

        <Label className="pad-responsive-t">
          {LABELCONST.AMEX_CONTACT_BUSINESS_UNIT}
        </Label>
        <Input
          id="amexContactBusinessUnit"
          maxLength={120}
          value={formData.amexContactBusinessUnit}
          onChange={(event) =>
            setFormData({
              ...formData,
              amexContactBusinessUnit: event.target.value,
            })
          }
        />
      </div>
    </div>
  );
};

export default AmexContactInfo;
